/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import{JSONMap as o}from"../../core/jsonMap.js";const t=new o({connected:"connected",upstream:"upstream",downstream:"downstream",shortestPath:"shortest-path",subnetwork:"subnetwork","subnetwork controllers":"subnetwork-controllers",loops:"loops",isolation:"isolation"});export{t as traceTypeKebabDict};
